import React, { useState, useEffect } from 'react'
import NavBar from '../components/NavBar';
import Error from '../components/Error';
import Loader from '../components/Loader';
import Footer from '../components/Footer';
import { FaCheck, FaRegCopy } from 'react-icons/fa';
import './Treningy.css';

const CLUB_IBAN = 'SK31 0200 0000 0034 6761 8051';

const copyToClipboard = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(text);
            return;
        } catch {
            // Ak prehliadač zablokuje moderné Clipboard API, použije sa záložný spôsob.
        }
    }

    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();

    const copied = document.execCommand('copy');
    document.body.removeChild(textArea);

    if (!copied) {
        throw new Error('IBAN sa nepodarilo skopírovať.');
    }
};


function Treningy(props) {
    const pageName = "Treningy.js"
    const config = require('../config')
    const debug = config.DEBUG
    if(debug) { console.log(pageName) }

    const [completed, setCompleted] = useState(false)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    useEffect(() => {
        if(debug) { console.log(pageName + ' loading ...') }

        // things to do 

        if(debug) { console.log(pageName + ' loading done.') }
        setCompleted(true)
        setLoading(false)
        setError(false)
    }, [debug])


    return (
        <div className="container">
            <NavBar />

            {loading && <Loader />}
            {error && <Error />}
            {completed ? (<DefaultContent />) : (<Error />)}

            <Footer />
        </div>


    )

}

const DefaultContent = () => {
    const [copyStatus, setCopyStatus] = useState('idle');

    useEffect(() => {
        if (copyStatus === 'idle') {
            return undefined;
        }

        const resetStatus = window.setTimeout(() => setCopyStatus('idle'), 2000);
        return () => window.clearTimeout(resetStatus);
    }, [copyStatus]);

    const handleCopyIban = async () => {
        try {
            await copyToClipboard(CLUB_IBAN);
            setCopyStatus('copied');
        } catch {
            setCopyStatus('error');
        }
    };

    const copyButtonText = copyStatus === 'copied'
        ? 'Skopírované'
        : copyStatus === 'error' ? 'Skúsiť znova' : 'Kopírovať';

    return (
        <div>
            <div className="jumbotron my-4">

                <h1 className="display-4">Tréningy</h1>
                <h2 className="display-6">časový harmonogram tréningov 2025/2026</h2>
            </div>

            <div>    
            <img src="/images/rozvrh.jpeg" className="img-fluid" alt="Rozvrh" />            

            </div>

            <hr />

            <div className="row align-items-stretch training-details">
                <div className="col-12 col-lg-7 mb-4">
                    {/* <h3>VYSVETLIVKY </h3>
                    <ul>
                        <li>1.SKUPINA - rok narodenia 2008 - 2011</li>
                        <li>2.SKUPINA - rok narodenia 2011 - 2013</li>
                        <li>3.SKUPINA - rok narodenia 2013 - 2015</li>
                        <li>4.SKUPINA - rok narodenia 2016 - 2017</li>
                        <li>DORAST - MUŽI - rok narodenia 2007 - NEOBMEDZENE</li>
                    </ul> */}
                    <section className="payment-card" aria-labelledby="payment-heading">
                        <div className="payment-card__symbol" aria-hidden="true">€</div>
                        <div className="payment-card__content">
                            <p className="payment-card__eyebrow">Platobné údaje</p>
                            <h3 id="payment-heading">Platba členského príspevku</h3>
                            <p className="payment-card__intro">
                                Platby za členský príspevok Judo klubu Levice realizujte na účet:
                            </p>

                            <dl className="payment-card__details">
                                <div>
                                    <dt>IBAN</dt>
                                    <dd className="payment-card__iban-row">
                                        <span className="payment-card__iban">{CLUB_IBAN}</span>
                                        <button
                                            type="button"
                                            className={`payment-card__copy${copyStatus === 'copied' ? ' payment-card__copy--success' : ''}`}
                                            onClick={handleCopyIban}
                                            aria-label="Skopírovať IBAN do schránky"
                                        >
                                            {copyStatus === 'copied'
                                                ? <FaCheck aria-hidden="true" />
                                                : <FaRegCopy aria-hidden="true" />}
                                            <span aria-live="polite">{copyButtonText}</span>
                                        </button>
                                    </dd>
                                </div>
                                <div>
                                    <dt>Variabilný symbol</dt>
                                    <dd className="payment-card__reference">MENO + PRIEZVISKO + MESIAC</dd>
                                </div>
                            </dl>
                        </div>
                    </section>
                </div>

                <div className="col-12 col-lg-5 mb-4">
                    <section className="membership-card" aria-labelledby="membership-heading">
                        <h3 id="membership-heading">Členský príspevok</h3>
                        <ul className="membership-card__list">
                            <li>
                                <span>Mesačný členský príspevok</span>
                                <strong>50 &euro;</strong>
                                <ul>
                                    <li><span>2 súrodenci</span><strong>45 &euro; / mesiac</strong></li>
                                    <li><span>3 súrodenci</span><strong>40 &euro; / mesiac</strong></li>
                                </ul>
                            </li>
                            {/* <li>Mesačná permanentka deti a študenti - 25 &euro;</li>
                            <li>Mesačná permanentka dorast a muži - 30 &euro;</li> */}
                            <li><span>Jednorazový vstup</span><strong>5 &euro;</strong></li>
                        </ul>
                    </section>
                </div>
            </div>


            			
			
			
			
        </div>

    )
}


export default Treningy
